var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.26562 7C4.26562 7.30204 4.51046 7.54688 4.8125 7.54688H6.45312V9.1875C6.45312 9.48954 6.69796 9.73438 7 9.73438C7.30204 9.73438 7.54688 9.48954 7.54688 9.1875V7.54688H9.1875C9.48954 7.54688 9.73438 7.30204 9.73438 7C9.73438 6.69796 9.48954 6.45312 9.1875 6.45312H7.54688V4.8125C7.54688 4.51046 7.30204 4.26562 7 4.26562C6.69796 4.26562 6.45312 4.51046 6.45312 4.8125V6.45312H4.8125C4.51046 6.45312 4.26562 6.69796 4.26562 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.38621 1.68993L5.09357 1.39691C5.37258 1.2813 5.50512 0.96141 5.38951 0.682367C5.2739 0.403324 4.95403 0.270735 4.67496 0.386426L3.96761 0.679442C3.68859 0.795051 3.55606 1.11495 3.67167 1.39399C3.78689 1.6721 4.10627 1.80581 4.38621 1.68993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 0C6.69796 0 6.45312 0.244836 6.45312 0.546875C6.45312 0.848914 6.69796 1.09375 7 1.09375C10.2642 1.09375 12.9062 3.73537 12.9062 7C12.9062 10.2642 10.2646 12.9062 7 12.9062C3.73576 12.9062 1.09375 10.2646 1.09375 7C1.09375 6.69796 0.848914 6.45312 0.546875 6.45312C0.244836 6.45312 0 6.69796 0 7C0 10.8687 3.13078 14 7 14C10.8687 14 14 10.8692 14 7C14 3.13132 10.8692 0 7 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.55299 3.09448L3.09437 2.5531C3.30795 2.33952 3.30795 1.99324 3.09437 1.77968C2.88079 1.56613 2.5345 1.5661 2.32095 1.77968L1.77957 2.32106C1.56599 2.53464 1.56599 2.88093 1.77957 3.09448C1.9931 3.30801 2.33941 3.30806 2.55299 3.09448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.682207 5.38953C0.961852 5.50535 1.28142 5.37197 1.39675 5.09358L1.68977 4.3862C1.80538 4.10716 1.67284 3.78726 1.39383 3.67165C1.11473 3.55607 0.794891 3.68858 0.679281 3.9676L0.386266 4.67495C0.270656 4.95402 0.403192 5.27392 0.682207 5.38953Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.e59bf25a.svg";
export { ForwardRef as ReactComponent };